import { type AxiosResponse } from 'axios';

import {
  DatePickerOmitIdType,
  DatePickerType,
  CreatePoolRewardType,
  type AddUserPoolType,
  type PoolType,
  AddUserRewardType,
} from '@/types';
import { camelToSnakeCase } from '@/lib/convert-code-style';

import { axiosPost } from '@/api/AxiosApi';
import { sendRequest } from '@/api/AxiosRequest';
import { type CustomAxiosResponse } from '@/api/AxiosResponse';

export const createPool = async (aData: PoolType): Promise<CustomAxiosResponse> => {
  const payload = {
    path: '/staking-setting',
    body: { ...aData },
  };
  return sendRequest(payload, 'createPool', axiosPost);
};
// 사용자 스테이킹 수동 등록
export const addUserPool = async (aData: AddUserPoolType): Promise<CustomAxiosResponse | AxiosResponse> => {
  const payload = {
    path: '/staking-admins',
    body: { ...aData },
  };
  return sendRequest(payload, 'addUserPool', axiosPost);
};

// 풀 리워드 기간 설정
export const createPoolReward = async (createPoolRewardType: CreatePoolRewardType[]) => {
  const payload = {
    path: '/staking-setting-reward',
    body: createPoolRewardType,
  };
  return sendRequest(payload, 'createPoolReward', axiosPost);
};

// 사용자 리워드 수동 등록
export const addUserReward = async (addUserRewardType: AddUserRewardType) => {
  console.log(addUserRewardType);
  const payload = {
    path: '/staking-admins/reward',
    body: addUserRewardType,
  };
  return sendRequest(payload, 'addUserReward', axiosPost);
};
